export const cards = [
  {
    "cardNo": "1234-5678-9012-3456",
    "createDate": "2022-01-01",
    "expiryDate": "2025-01-01",
    "balance": 1000.0,
    "totalRemaining": 500.0,
    "status": "actif",
    "categoryId": "Mineur"
  },
  {
    "cardNo": "9876-5432-1098-7654",
    "createDate": "2022-06-01",
    "expiryDate": "2026-06-01",
    "balance": 2000.0,
    "totalRemaining": 1000.0,
    "status": "actif",
    "categoryId": "Majeur"
  },
  {
    "cardNo": "1111-2222-3333-4444",
    "createDate": "2022-03-01",
    "expiryDate": "2025-03-01",
    "balance": 500.0,
    "totalRemaining": 250.0,
    "status": "inactif",
    "categoryId": "mineur"
  },
  {
    "cardNo": "5555-6666-7777-8888",
    "createDate": "2022-09-01",
    "expiryDate": "2026-09-01",
    "balance": 1500.0,
    "totalRemaining": 750.0,
    "status": "actif",
    "categoryId": "mineur"
  },
  {
    "cardNo": "9999-8888-7777-6666",
    "createDate": "2022-12-01",
    "expiryDate": "2027-12-01",
    "balance": 2500.0,
    "totalRemaining": 1250.0,
    "status": "actif",
    "categoryId": "Majeur"
  },
  {
    "cardNo": "3333-4444-5555-6666",
    "createDate": "2022-02-01",
    "expiryDate": "2025-02-01",
    "balance": 800.0,
    "totalRemaining": 400.0,
    "status": "inactif",
    "categoryId": "Majeur"
  },
  {
    "cardNo": "7777-6666-5555-4444",
    "createDate": "2022-08-01",
    "expiryDate": "2026-08-01",
    "balance": 1200.0,
    "totalRemaining": 600.0,
    "status": "actif",
    "categoryId": "Mineur"
  },
  {
    "cardNo": "4444-5555-6666-7777",
    "createDate": "2022-11-01",
    "expiryDate": "2027-11-01",
    "balance": 1800.0,
    "totalRemaining": 900.0,
    "status": "actif",
    "categoryId": "majeur"
  }
]